import React from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom';
import moment from 'moment-timezone'
import _ from 'lodash'

import { Modal, Tabs, Button } from 'components'
import { ItemBlock, PageBlock, ItemModal } from 'features'
import { FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import { AnimatePresence, motion } from 'framer-motion';

import * as actionCreators from 'store/actions'
import * as api from 'api'

const Container = styled.div`
    padding: 2rem 2rem 2rem 2rem;
    border-radius: 5px;
    width: 30rem;
    height: 90vh;
    overflow-y: hidden;
    overflow-x: hidden;
    background: var(--primary-color);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    border-radius: 5px;
    box-shadow: var(--box-shadow);
    @media (max-width: 600px) {
        width: 80vw;
    }
`

const Header = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
`

const Title = styled.div`
    font-size: 1.5rem;
    font-weight: bold;
    margin-left: 0.5rem;
`

const Tab = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`

const Indicator = styled.div`
    font-size: 0.8rem;
    margin-left: 0.5rem;
    /* color: var(--secondary-accent-color); */
    font-weight: bolder;
`

const Body = styled.div`
    height: 100%;
    width: 100%;
    flex-grow: 4;
    overflow-x: hidden;
`

const Wrapper = styled.div`
    width: 200%;
    height: inherit;
    display: grid;
    grid-template-columns: 50% 50%;
    overflow: hidden;
`

const Column = styled.div`
    display: flex;
    flex-direction: column;
    overflow: auto;
`

const Placeholder = styled.div`
    color: var(--secondary-accent-color);
    margin: 0.5rem 0.5rem;
    font-size: 0.8rem;
`

const iconStyles = {
    backgroundColor: 'var(--primary-color)', 
    margin: 0, padding: '0.5rem', 
    borderColor: 'transparent', 
    boxShadowColor: 'transparent'
}

const DayModal = props => {
    const {
        // date,
        values,
    } = props;
    const dispatch = useDispatch()
    let history = useHistory()

    const [date, setDate] = React.useState(moment(props.date))
    const [index, setIndex] = React.useState(props.index)
    const [totals, setTotals] = React.useState(() => {
        const completed = values.find(y => y['label'] === 'completed')['data'][props.index]
        const scheduled = values.find(y => y['label'] === 'scheduled')['data'][props.index]
        return { completed, scheduled }
    })
    const data = useSelector(state => state.db.present.data && state.db.present.data.toJS())
    const user = useSelector(state => state.auth.user)
    const [tab, setTab] = React.useState('COMPLETED')

    const onSelectPage = (pageID) => {
        const oldUser = {...user}
        let updatedUser = {...user}
        updatedUser['activePageID'] = pageID
        updatedUser['activePageType'] = 'Pages'
        dispatch(actionCreators.setModal(null,null))
        dispatch(actionCreators.updateUser(updatedUser, oldUser))
        history.push(pageID.toLowerCase())
        window.scrollTo(0,0)
    }

    const getBlocks = () => {
        // Blocks
        let blocks = {
            COMPLETED: [],
            SCHEDULED: []
        }
        let counts = {
            COMPLETED: 0,
            SCHEDULED: 0
        }
        Object.keys(blocks).forEach(key => {
            const feature = key === 'COMPLETED' ? 'completed_date' : 'end_date'
            const items = Object.values(data['items']).filter(item => item[feature] && moment(item[feature]).format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD'))
            const pageIDs = _.uniq(items.map(item => item['pageID']))
            pageIDs.forEach(pageID => {
                blocks[key].push(
                    <PageBlock key={pageID} page={data['pages'][pageID]} disableButtons
                        style={{size: '1.2rem', fontSize: '1.2rem', padding: '0.5rem', backgroundColor: 'var(--primary-color)', borderRadius: '5px', borderBottom: '1px solid var(--secondary-color)'}}
                        onSelect={() => onSelectPage(pageID)}/>
                )

                const pageItems = items.filter(item => item['pageID'] === pageID)
                pageItems.forEach(item => {
                    blocks[key].push(
                        <ItemBlock type='VIEW' key={item.itemID} itemID={item['itemID']}
                            primaryColor='var(--primary-color)' 
                            onSelect={() => dispatch(actionCreators.setModal(<ItemModal itemID={item['itemID']}/>, `${item.itemID}_ItemModal`))}/>
                    )
                    counts[key] = counts[key] + 1
                })
            })

            // Placeholers
            if(blocks[key].length === 0) {
                blocks[key].push(<Placeholder>{`No ${key.toLowerCase()} items`}</Placeholder>)
            }
        })

        return {
            SCHEDULED: <Column>{blocks['SCHEDULED']}</Column>,
            COMPLETED: <Column>{blocks['COMPLETED']}</Column>,
            SCHEDULED_COUNT: counts['SCHEDULED'],
            COMPLETED_COUNT: counts['COMPLETED']
        }
    }
    const blocks = getBlocks()

    const onToggleDate = (direction) => {
        const newDate = direction === 'INCREASE' ? moment(date).add(1, 'day') : moment(date).subtract(1,'day')
        setDate(newDate)

        const newIndex = direction === 'INCREASE' ? index + 1 : index - 1
        setIndex(newIndex)

        const completed = values.find(y => y['label'] === 'completed')['data'][newIndex]
        const scheduled = values.find(y => y['label'] === 'scheduled')['data'][newIndex]
        setTotals({completed, scheduled})
    }

    return (
        <Modal onClose={() => dispatch(actionCreators.setModal(null,null))}>
            <Container>
                <Header>
                    <Title>{moment(date).format('ddd, D-MMM')}</Title>
                        
                    <div style={{display: 'flex', marginRight: '0.5rem'}}>
                        <Button icon={<FaChevronLeft/>} styles={iconStyles} onSelect={() => onToggleDate('DECREASE')}/>
                        <Button icon={<FaChevronRight/>} styles={iconStyles} onSelect={() => onToggleDate('INCREASE')}/>
                        <div style={{border: '1px solid var(--secondary-color)', margin: '0 0.5rem', width: '1px'}}/>
                        <Button icon={<FaTimes/>} styles={iconStyles} onSelect={() => dispatch(actionCreators.setModal())}/>
                    </div>
                </Header>

                {/* Tabs */}
                <Tabs selected={tab} onSelect={value => setTab(value)}
                        styles={{ 
                            main: { backgroundColor: 'var(--secondary-color)', width: '100%' },
                            tab: { padding: '0.5rem 0' }
                        }}
                        options={{
                            COMPLETED: <Tab>
                                            <div>Completed</div>
                                            <Indicator>{totals['completed'] ? totals['completed'] : blocks['COMPLETED_COUNT']}</Indicator>
                                        </Tab>,
                            CREATEED: <Tab>
                                        <div>Scheduled</div>
                                        <Indicator>{totals['scheduled'] ? totals['scheduled'] : blocks['SCHEDULED_COUNT']}</Indicator>
                                    </Tab>
                        }}
                        />
                
                {/* Items */}
                <Body>
                    <AnimatePresence initial={false}>
                        <motion.div key='completed' 
                            initial={tab === 'COMPLETED' ? "right" : 'left'}
                            animate={tab === 'COMPLETED' ? "left" : 'right'}
                            exit={tab === 'COMPLETED' ? "right" : 'left'}
                            variants={{
                                left: { x: 0, height: '100%' },
                                right: { x: '-100%', height: '100%' }
                            }}
                            transition={{ duration: 0.3 }}>
                            <Wrapper>
                                {blocks['COMPLETED']}
                                {blocks['SCHEDULED']}
                            </Wrapper>
                        </motion.div>
                    </AnimatePresence>
                </Body>

            </Container>
        </Modal>
    )
}

export default DayModal